import { Hub, Auth } from 'aws-amplify'
import { issueShopAuthCookies, revokeShopAuthCookies } from '@/services/CookieService'

// Listen for auth events globally (no Vue dependency)
Hub.listen('auth', async ({ payload }) => {
    if (payload.event === 'tokenRefresh') {
        try {
            const session = await Auth.currentSession()
            await issueShopAuthCookies({
                idToken: session.getIdToken().getJwtToken(),
            })
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('[AmplifyAuthEvents] tokenRefresh handler failed:', e)
        }
    }

    // Clear cross-domain cookies when user signs out (whether invoked
    // programmatically or by another tab)
    if (payload.event === 'signOut') {
        try {
            await revokeShopAuthCookies()
        } catch (e) {
            console.error('[AmplifyAuthEvents] signOut handler failed:', e)
        }
    }
}) 